module.exports = __webpack_public_path__ + "static/sune-symbol-SCAG-a67f6d42c42634e1fe47160b8b496911.png";